
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/archive-and-research-area",
      function () {
        return require("private-next-pages/collections-and-research/archive-and-research-area/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/archive-and-research-area"])
      });
    }
  